import { useQuery } from '@apollo/client';
import { GetAttestationConfigDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

export const useGetAttestationConfig = (parentDocumentId: string) => {
  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
    error: graphqlError,
  } = useQuery(GetAttestationConfigDocument, {
    fetchPolicy: 'no-cache',
    variables: { id: parentDocumentId },
    skip: !parentDocumentId,
  });

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
    error: graphqlError,
  };
};
